import { useState } from "react";
import axios from "axios";
import { useLocalStorage } from "./useLocalStorage";

const useGetMovies = (url) => {
  const [movies, setMovies] = useLocalStorage("movies", "");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  async function getMovies() {
    try {
      const response = await axios.get(url);
      const result = response.data.results;
      setMovies(result);
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }

  return { movies, loading, error, getMovies };
};

export default useGetMovies;
